/**
 * Benefits Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initBenefits() {
        const blocks = document.querySelectorAll('.benefits');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] benefits block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBenefits);
    } else {
        initBenefits();
    }
})();